import {
    SCHEDULE_ITEMS_FETCH,
    SCHEDULE_ITEMS_FETCHED,
    SCHEDULE_ITEMS_FETCH_ERROR,
    SCHEDULE_ITEM_CUD_SUCCESS,
    SCHEDULE_ITEM_CUD_ERROR,
    SCHEDULE_ITEM_CUD
} from "../actions/schedule";

const initialState = {
    colors: [],
    types: [],
    associations: [],
    sessions: [],
    loading: false,
    error: false,
    updating: false,
    update_error: false,
    message: null
}

function schedule(state = initialState, action) {
    switch (action.type) {
        case SCHEDULE_ITEMS_FETCH: {
            return {
                ...state,
                loading: true,
                error: false
            }
        }
        case SCHEDULE_ITEMS_FETCHED: {
            const {
                colors,
                types,
                associations,
                sessions
            } = action.payload
            return {
                ...state,
                colors,
                types,
                associations,
                sessions,
                loading: false,
                error: false
            }
        }
        case SCHEDULE_ITEMS_FETCH_ERROR: {
            return {
                ...state,
                loading: false,
                error: true
            }
        }
        case SCHEDULE_ITEM_CUD: {
            // console.log(SCHEDULE_ITEM_CUD, action.payload)
            return {
                ...state,
                updating: true,
                update_error: false,
                message: null
            }
        }
        case SCHEDULE_ITEM_CUD_SUCCESS: {
            // {
            //     "message": "color.create-success",
            //     "data": {
            //       "_id": "5a80218721686758c2efe236",
            //       "name": "brown",
            //       "color": "#aa7942",
            //       "user_id": "587f01d71234630004a4ce53",
            //       "__v": 0
            //     },
            //     "collection": "color",
            //     "action": "create"
            //   }
            if (action.payload.action === "delete") {
                const rows = state[`${action.payload.collection}s`]
                const deleted_row = action.payload.data
                const index = rows.findIndex(r => r._id === deleted_row._id)
                rows.splice(index, 1)
                const newState = state
                newState[action.payload.collection] = rows
                return {
                    ...state,
                    ...newState,
                    updating: false,
                    update_error: false,
                    message: action.payload.message
                }
            } else {
                // Create and Update reload dashboard page, need not handle
                return {
                    ...state,
                    updating: false,
                    update_error: false,
                    message: action.payload.message
                }
            }
        }
        case SCHEDULE_ITEM_CUD_ERROR: {
            return {
                ...state,
                updating: false,
                update_error: true
            }
        }
        default:
            return state
    }
}

export default schedule
